export const updateFeeAmounts = (isNew, feeConfirmation, setFieldValue) => {
  if (!feeConfirmation) {
    throw Error("No fee confirmation provided");
  }

  const {
    newChuffedAmount,
    newFeeAmount,
    newPaymentMethod,
    oldChuffedAmount,
    oldFeeAmount,
    oldPaymentMethod,
  } = feeConfirmation;

  const updatedChuffedAmount = (isNew ? newChuffedAmount : oldChuffedAmount) || 0;

  if (setFieldValue) {
    setFieldValue("chuffedAmount", updatedChuffedAmount);
    setFieldValue("feeAmount", isNew ? newFeeAmount : oldFeeAmount);
    setFieldValue("paymentMethod", isNew ? newPaymentMethod : oldPaymentMethod);
  }

  return {
    chuffedAmount: updatedChuffedAmount,
    feeAmount: isNew ? newFeeAmount : oldFeeAmount,
    paymentMethod: isNew ? newPaymentMethod : oldPaymentMethod,
    newChuffedAmount,
    newFeeAmount,
  };
};

export const closeFeeConfirmation = (handlers) => {
  const {
    setFeeConfirmation,
    setProcessingSubmit,
  } = handlers;

  setFeeConfirmation({
    isVisible: false,
    isSubmittingFromConfirmation: false,
  });

  setProcessingSubmit(false);
};
